import { MessageCircle, Phone } from "lucide-react";
import { BUSINESS, createWhatsAppLink } from "@/config/business";

const base =
  "inline-flex items-center justify-center gap-2 rounded-full font-semibold min-h-[44px] transition-[background-color,transform,box-shadow,border-color] duration-200 focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-[#C5A059] focus-visible:ring-offset-2";

const sizes = {
  md: "px-6 py-3 text-sm sm:text-base",
  lg: "px-8 py-4 text-base sm:text-lg",
  sm: "px-4 py-2.5 text-sm",
};

export const WhatsAppButton = ({
  message,
  label = "Book on WhatsApp",
  testId,
  className = "",
  size = "md",
}) => (
  <a
    href={createWhatsAppLink(message)}
    target="_blank"
    rel="noopener noreferrer"
    data-testid={testId}
    aria-label={`${label} — opens WhatsApp chat with GK Wellness`}
    className={`${base} ${sizes[size]} bg-[#22a355] text-white shadow-[0_4px_20px_-2px_rgba(34,163,85,0.45)] hover:bg-[#1e9e4f] hover:shadow-[0_10px_28px_-4px_rgba(34,163,85,0.5)] hover:-translate-y-0.5 active:translate-y-0 ${className}`}
  >
    <MessageCircle className="h-5 w-5 shrink-0" aria-hidden="true" />
    <span>{label}</span>
  </a>
);

export const CallButton = ({
  label = `Call ${BUSINESS.phoneDisplay}`,
  testId,
  className = "",
  size = "md",
  variant = "outline",
}) => {
  const variants = {
    outline:
      "border border-[#1C1917]/25 bg-white/80 text-[#1C1917] hover:border-[#1C1917] hover:bg-white",
    onDark:
      "border border-white/40 bg-white/10 text-white backdrop-blur-sm hover:bg-white/20 hover:border-white/70",
    gold: "bg-[#C5A059] text-white shadow-[0_4px_20px_-2px_rgba(197,160,89,0.5)] hover:bg-[#B38D46]",
  };
  return (
    <a
      href={BUSINESS.tel}
      data-testid={testId}
      aria-label={`Call GK Wellness on ${BUSINESS.phoneIntl}`}
      className={`${base} ${sizes[size]} ${variants[variant]} hover:-translate-y-0.5 active:translate-y-0 ${className}`}
    >
      <Phone className="h-5 w-5 shrink-0" aria-hidden="true" />
      <span>{label}</span>
    </a>
  );
};
